import { ThemeChrome } from "@/components/theme";
import AppRoutes from "@/router/app-routes";
import StoreProvider from "./services/features/StoreProvider";
import QueryClientContextProvider from "./services/QueryClientContextProvider";
import { NotificationsProvider } from "./context/NotificationsContext";
import { WebSocketProvider } from "./context/WebSocketContext";

export default function App() {
  return (
    <>
      <StoreProvider>
        <QueryClientContextProvider>
          <NotificationsProvider>
            <WebSocketProvider>
              <ThemeChrome />
              <AppRoutes />
            </WebSocketProvider>
          </NotificationsProvider>
        </QueryClientContextProvider>
      </StoreProvider>
    </>
  );
}
